import { useEffect } from 'react'

const Terms = () => {
  useEffect(() => {
    window.location.href = 'https://www.acorns.com/terms/'
  }, [])
  return null
}

export default Terms
